var _excluded = ["items", "selectedItemIndex", "sortDirection", "trigger"],
    _excluded2 = ["dataTestId", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { cloneElement } from 'react';
import { forwardRef } from '../../utils';
import { Menu } from '../Menu';
import { SortItem } from './SortItem/SortItem';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export var SortDropdownMenu = forwardRef((_ref, ref) => {
  var {
    items,
    selectedItemIndex,
    sortDirection,
    trigger
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var triggerWithProps = /*#__PURE__*/cloneElement(trigger, {
    'data-component': 'SortDropdownMenu'
  });
  return /*#__PURE__*/_jsx(Menu, _objectSpread(_objectSpread({
    "data-testid": "sort-dropdown-menu"
  }, props), {}, {
    trigger: triggerWithProps,
    ref: ref,
    children: items.map((_ref2, index) => {
      var {
        dataTestId,
        onClick: _onClick
      } = _ref2,
          itemProps = _objectWithoutProperties(_ref2, _excluded2);

      return /*#__PURE__*/_createElement(SortItem, _objectSpread(_objectSpread({}, itemProps), {}, {
        "data-testid": dataTestId !== null && dataTestId !== void 0 ? dataTestId : "sort-dropdown-menu-item-".concat(index),
        sortDirection: selectedItemIndex === index ? sortDirection : 'none',
        onClick: () => _onClick === null || _onClick === void 0 ? void 0 : _onClick(index),
        key: index
      }));
    })
  }));
});
SortDropdownMenu.displayName = 'SortDropdownMenu';
//# sourceMappingURL=SortDropdownMenu.js.map